import React, { FC, useEffect, useState } from "react"

import { Form, Divider } from "antd"
import { UploadComponent, FormElement } from "components"
import { ContestConfigSchedulePageData } from "domains/managingJson/store/types"

export const ContestNotStartedSchedule: FC<{ data?: ContestConfigSchedulePageData; form: any }> = ({
  data,
  form,
}) => {
  const [image, setImage] = useState(data?.image || "")

  useEffect(() => {
    if (data) {
      setImage(data?.image)
    }
  }, [data])
  useEffect(() => {
    const arr = {}
    arr["contestNotStartedSchedule"] = { image }
    form.setFieldsValue({ ...arr })
  }, [image, form])

  return (
    <>
      <Divider>Not started schedule </Divider>
      <div>
        <FormElement
          type="input"
          label="ContestNotStartedSchedule title "
          name={["contestNotStartedSchedule", "title"]}
          initialValue={data?.title}
          required
        />

        <FormElement
          type="text"
          label="ContestNotStartedSchedule text "
          name={["contestNotStartedSchedule", "text"]}
          initialValue={data?.text}
          required
        />

        <Form.Item name={["contestNotStartedSchedule", "image"]} initialValue={image}>
          <UploadComponent
            image={image}
            setImage={setImage}
            placeholder="Contest NotStarted Schedule Image "
            title="Contest NotStarted Schedule Image "
            required
          />
        </Form.Item>
      </div>
    </>
  )
}
